<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <b-card>
        <Toast />
        <Toast position="top-right" group="tr" :baseZIndex="10000" />
        <ConfirmDialog></ConfirmDialog>
        <DataTable ref="dt" :value="AllAgreementDocuments" :selection.sync="selectedAgreementDocuments" :paginator="true" showGridlines :rows="10"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown" :rowsPerPageOptions="[5,10,25]"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} records"
          dataKey="Id" :filters="filters" filterDisplay="menu" :loading="loading" responsiveLayout="scroll"
          @page="manageRowNumber"
          :globalFilterFields="['Name', 'Path', 'Code']" class="p-datatable-sm">
          <template #header>
            <div class="flex justify-content-between">
              <h5 class="mb-2 md:m-0 md:align-self-center">Senarai Dokumen Perjanjian</h5>
              <!--
              <Button label="Tambah" icon="pi pi-plus" class="p-button-sm p-button-primary mr-2" @click="openAddAgreementDocument()"/>
              <Button label="Export" icon="pi pi-upload" class="p-button-sm p-button-help" @click="exportCSV($event)"/>
              -->
              <span class="p-input-icon-left">
                <i class="pi pi-search" />
                <InputText v-model="filters['global'].value" placeholder="Cari..." />
              </span>
            </div>
          </template>
          <Column selectionMode="multiple" :styless="{width: '2rem'}" :exportable="false"></Column>
          <Column header="Bil" headerStyle="width:3em">
            <template #body="slotProps">
              {{pageStartRowNumber+slotProps.index+1}}
            </template>
          </Column>
          <Column header="Id" field="Id" :sortable="true" :styles="{'min-width':'4rem'}"></Column>
          <Column header="Nama" field="Name" :sortable="true" :styles="{'min-width':'4rem'}"></Column>
          <Column header="Link" field="Path" :sortable="true" :styles="{'min-width':'4rem'}">
            <template #body="slotProps">
              <a v-if="null!=slotProps.data.Path && 0<slotProps.data.Path.length && 'Janaan'!=slotProps.data.Path" :href="slotProps.data.Path" target="_blank">{{slotProps.data.Path}}</a>
              <span v-else>Janaan</span>
            </template>
          </Column>
          <!--
          <Column header="Program" field="Code" :sortable="true" :styles="{'min-width':'4rem'}"></Column>
          -->
          <Column header="Program" field="Code" filterField="Code" :showFilterMatchModes="false" :filterMenuStyle="{'width':'14rem'}" sortField="Code" :sortable="true" style="min-width:14rem"
            :showClearButton="false" :showApplyButton="false">
            <template #body="{data}">
              <span class="image-text">{{data.Code}}</span>
            </template>
              <template #filter="{}">
                <div class="mb-3 font-bold">Pilih Program</div>
                <MultiSelect v-model="filters['Code'].value" :options="programList" optionLabel="" placeholder="Sila Pilih" class="p-column-filter"
                  :filter="true">
                  <template #option="slotProps">
                    <div>
                      <span class="image-text">{{slotProps.option}}</span>
                    </div>
                  </template>
                </MultiSelect>
              </template>
          </Column>
          <Column :exportable="false" style="min-width:8rem" :bodyStyle="{'text-align':'center'}">
            <template #body="slotProps">
              <Button icon="pi pi-pencil" class="p-button-rounded p-button-success mr-1 mb-1" @click="openUpdateAgreementDocument(slotProps.data)" />
              <!--
              <Button icon="pi pi-trash" class="p-button-rounded p-button-danger mr-1 mb-1" @click="softDeleteAgreementDocument(slotProps.data)" />
              -->
            </template>
          </Column>
        </DataTable>
        <Dialog header="Tambah Dokumen Perjanjian" :visible.sync="displayAddAgreementDocument" :breakpoints="{'960px': '75vw', '640px': '90vw'}" :containerStyle="{width: '50vw'}"
          :contentStyle="{overflow: 'visible'}"
          :modal="true"
          :maximizable="true">
          <div class="p-fluid">
            <div class="field">
              <span>
                <small>Program</small>
                <Dropdown v-model="ProgramName" :options="AllPrograms" optionLabel="Name" :filter="true" placeholder="Sila Pilih" :showClear="true" 
                  class="p-inputtext-sm" style="width:100%; box-sizing: border-box;" inputStyle="width: 100%; box-sizing: border-box;">
                  <template #value="slotProps">
                    <div v-if="slotProps.value">
                      <div>{{slotProps.value.Name}}</div>
                    </div>
                    <span v-else>
                      {{slotProps.placeholder}}
                    </span>
                  </template>
                  <template #option="slotProps">
                    <div>
                      <div>{{slotProps.option.Name}}</div>
                    </div>
                  </template>
                </Dropdown>
              </span>
              <span>
                <small>Nama Dokumen Perjanjian Di Skrin Tawaran</small>
                  <AutoComplete v-model="AgreementDocumentName" :suggestions="filteredAgreementDocuments" @complete="searchAgreementDocument($event)" field="Name" 
                    class="p-invalid p-inputtext-sm" v-if="((0<filteredAgreementDocuments.length)&&(0<AgreementDocumentName.length))" />
                  <AutoComplete v-model="AgreementDocumentName" :suggestions="filteredAgreementDocuments" @complete="searchAgreementDocument($event)" field="Name" 
                    class="p-inputtext-sm" v-else />
              </span>
              <span>
                <a v-if="false==generatedSwitch && null!=Path && 0<Path.length" :href="Path" target="_blank">{{Path}}</a>
              </span>
              <table width="100%">
                <tr style="vertical-align: top">
                  <td width="50%">
                    <span>
                      <small v-if="true==generatedSwitch">Janaan</small>
                      <small v-else>Muat turun</small>
                      <br>
                      <InputSwitch v-model="generatedSwitch" @change="setToggleGenratedSwitch()" />
                    </span>
                    <div v-if="false==generatedSwitch" class="mt-2">
                      <span>
                        Muatnaik dokumen perjanjian dalam format pdf
                      </span>
                      <br>
                      <span>
                        <input class="mt-1" type="file" id="file" ref="file" accept=".pdf" v-on:change="handleFileUploadV4()"/>
                      </span>
                      <br>
                      <span>
                        <b-button class="mt-2" type="submit" variant="info bg-primary" @click="submitFileV4()">
                          <i class="fa fa-dot-circle-o"></i> Muat Naik
                        </b-button>
                      </span>
                    </div>
                  </td>
                  <td style="padding-top: 10px">
                    Panduan
                    <br>
                    1. Pilih program
                    <br>
                    2. Pilih jenis dokumen perjanjian, janaan atau muat turun
                    <br>
                    3a. Untuk janaan, namakan dokumen perjanjian
                    <br>
                    4a. Simpan
                    <br>
                    3b. Untuk muat turun, pilih dokumen
                    <br>
                    4b. Namakan dokumen perjanjian
                    <br>
                    5b. Muat naik
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <template #footer>
            <Button label="Batal" @click="closeAddAgreementDocument()" autofocus />
            <Button :disabled="false==generatedSwitch" label="Simpan" @click="saveAddAgreementDocument()" />
          </template>
        </Dialog>
        <Dialog header="Kemaskini Dokumen Perjanjian" :visible.sync="displayUpdateAgreementDocument" :breakpoints="{'960px': '75vw', '640px': '90vw'}" :containerStyle="{width: '50vw'}"
          :contentStyle="{overflow: 'visible'}"
          :modal="true"
          :maximizable="true">
          <div class="p-fluid">
            <div class="field">
              <span>
                <small>Program</small>
                <Dropdown v-model="ProgramName" :options="AllPrograms" optionLabel="Name" :filter="true" placeholder="Sila Pilih" :showClear="true" 
                  :disabled="true" class="p-inputtext-sm" style="width:100%; box-sizing: border-box;" inputStyle="width: 100%; box-sizing: border-box;">
                  <template #value="slotProps">
                    <div v-if="slotProps.value">
                      <div>{{slotProps.value.Name}}</div>
                    </div>
                    <span v-else>
                      {{slotProps.placeholder}}
                    </span>
                  </template>
                  <template #option="slotProps">
                    <div>
                      <div>{{slotProps.option.Name}}</div>
                    </div>
                  </template>
                </Dropdown>
              </span>
              <span>
                <small>Nama Dokumen Perjanjian Di Skrin Tawaran</small>
                  <AutoComplete v-model="AgreementDocumentName" :suggestions="filteredAgreementDocuments" @complete="searchAgreementDocument($event)" field="Name" 
                    class="p-invalid p-inputtext-sm" v-if="((0<filteredAgreementDocuments.length)&&(0<AgreementDocumentName.length))" />
                  <AutoComplete v-model="AgreementDocumentName" :suggestions="filteredAgreementDocuments" @complete="searchAgreementDocument($event)" field="Name" 
                    class="p-inputtext-sm" v-else />
              </span>
              <span>
                <a v-if="false==generatedSwitch && null!=Path && 0<Path.length && 'Janaan'!=Path" :href="Path" target="_blank">{{Path}}</a>
              </span>
              <br>
              <table width="100%">
                <tr style="vertical-align: top">
                  <td width="50%">
                    <span>
                      <small v-if="true==generatedSwitch">Janaan</small>
                      <small v-else>Muat turun</small>
                      <br>
                      <InputSwitch :disabled="true" v-model="generatedSwitch" @change="setToggleGenratedSwitch()" />
                    </span>
                    <div v-if="false==generatedSwitch" class="mt-2">
                      <span>
                        Muatnaik dokumen perjanjian dalam format pdf
                      </span>
                      <br>
                      <span>
                        <input class="mt-1" type="file" id="file" ref="file" accept=".pdf" v-on:change="handleFileUploadV4()"/>
                      </span>
                      <br>
                      <span>
                        <b-button class="mt-2" type="submit" variant="info bg-primary" @click="submitFileV4()">
                          <i class="fa fa-dot-circle-o"></i> Muat Naik
                        </b-button>
                      </span>
                    </div>
                  </td>
                  <td style="padding-top: 10px; text-align:left">
                    Panduan
                    <br>
                    1. Pilih program
                    <br>
                    2. Pilih jenis dokumen perjanjian, janaan atau muat turun
                    <br>
                    3a. Untuk janaan, namakan dokumen perjanjian
                    <br>
                    4a. Simpan
                    <br>
                    3b. Untuk muat turun, pilih dokumen
                    <br>
                    4b. Namakan dokumen perjanjian
                    <br>
                    5b. Muat naik
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <template #footer>
            <Button label="Batal" @click="closeUpdateAgreementDocument()" autofocus />
            <Button :disabled="false==generatedSwitch" label="Simpan" @click="saveUpdateAgreementDocument()" />
          </template>
        </Dialog>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
//import DefaultOption from "../../../DefaultOption";
import _ from "lodash";
import Vue from "vue";
import moment from "moment";
Vue.use(require("vue-moment"));
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

import ConfirmationService from 'primevue/confirmationservice';
import PrimeVue from 'primevue/config';
import ToastService from 'primevue/toastservice';
Vue.use(ConfirmationService);
Vue.use(PrimeVue);
Vue.use(ToastService);
import AutoComplete from 'primevue/autocomplete';
import Button from 'primevue/button';
import Column from 'primevue/column';
import ConfirmDialog from 'primevue/confirmdialog';
import DataTable from 'primevue/datatable';
import Dialog from 'primevue/dialog';
import Dropdown from 'primevue/dropdown';
import { FilterMatchMode, FilterOperator } from "primevue/api";
import InputSwitch from 'primevue/inputswitch';
import InputText from 'primevue/inputtext';
import MultiSelect from 'primevue/multiselect';
import SplitButton from 'primevue/splitbutton';
import Toast from 'primevue/toast';
import 'primevue/resources/themes/saga-blue/theme.css';
import 'primevue/resources/primevue.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';

export default {
  name: "direktori-am-dokumenperjanjian",
  components: {
//    DefaultOption,
    PulseLoader,
    AutoComplete,
    Button,
    Column,
    ConfirmDialog,
    DataTable,
    Dialog,
    Dropdown,
    InputSwitch,
    InputText,
    MultiSelect,
    SplitButton,
    Toast,
  },
  data: function() {
    return {
      AgreementDocumentId: 0,
      AgreementDocumentName: null,
      AllAgreementDocuments: [],
      AllPrograms: [],
      displayAddAgreementDocument: false,
      displayUpdateAgreementDocument: false,
      filteredAgreementDocuments: [],
      filters: {},
      generatedSwitch: false,
      loading: true,
      pageStartRowNumber: 0,
      Path: null,
      pdfToBeUploaded: null,
      programList: null,
      ProgramName: null,
      ProgramNameOriginal: null,
      sCFN: 'DokumenPerjanjianV4: ',
      selectedAgreementDocuments: null,
    };
  },
  created() {
    this.initFilters();
  },
  async mounted() {
    let isAuth = await this.UserAuth();
    //this.AuthorizeUser();

    if (isAuth) {
      await this.getAllAgreementDocuments();
      this.loading = false;
    }
  },

  computed: {
  },
  methods: {
    closeAddAgreementDocument() {
      this.displayAddAgreementDocument = false;
    },
    closeUpdateAgreementDocument() {
      this.displayUpdateAgreementDocument = false;
    },
    exportCSV() {
      this.$refs.dt.exportCSV();
    },
    async getAllAgreementDocuments() {
      let fN = 'getAllAgreementDocuments: ';
      this.AllAgreementDocuments = [];
      return this.$API
        .get(this.$AgreementDocument, { withCredentials: true })
        .then(response => {
          if (response.status == 200 && response.data != null) {
            let arr = response.data;
            for (const item of arr) {
              let obj = item;
              let found = _.filter(this.AllAgreementDocuments, ["Id", obj.Id]);
              if (0 == found.length) {
                this.AllAgreementDocuments.push(obj);
              }
            }
            arr = _.orderBy(this.AllAgreementDocuments, ['Code'], ['asc']);
            arr = _.uniq(_.map(arr, 'Code'))
            arr = _.reject(arr, _.isNil);
            this.programList = arr;
            this.HTECHLogger(this.sCFN + fN + JSON.stringify(this.AllAgreementDocuments));
          } else {
            console.log(response.data.detail);
          }
        })
        .catch(error => {
          if (error.response) {
            console.log(error.response.status);
          }
        });
    },
    async getAllPrograms() {
      this.AllPrograms = [
        { Name: 'GREP'},
        { Name: 'IESP'},
        { Name: 'MESH'},
        { Name: 'PROP'},
        { Name: 'SKIPMA'},
        { Name: 'STEP'},
        { Name: 'TESP'},
        { Name: 'WTU'},
        { Name: 'YTP'}
      ];
      /*
      return this.$API
        .get(this.$ProgramV4, { withCredentials: true })
        .then(response => {
          if (response.status == 200 && response.data != null) {
            this.AllPrograms = response.data;
          }
      });
      */
    },
    handleAgreementDocument(item) {
      if (null != item.AgreementDocumentPath) {
        window.open(item.AgreementDocumentPath)
        //window.location.href = item.AgreementDocumentPath;
      }
    },
    handleFileUploadV4() {
      const files = event.target.files
      let filename = files[0].name
      var ext = filename.split('.').pop();
      if (ext != "pdf") {
        this.$dialog.alert("Muat naik fail pdf sahaja");
      } else {
        {
          const fileReader = new FileReader()
          fileReader.addEventListener('load', () => {
            this.documentUrl = fileReader.result
          })
          fileReader.readAsDataURL(files[0]);
          this.file = files[0];
          let obj = {
            name : this.file.name,
            file : files[0]
          }
          this.pdfToBeUploaded = obj;
          this.AgreementDocumentName = obj.name.replace(".pdf","");
        }
      }
    },
    initFilters() {
      this.filters = {
        'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
        'Code': {value: null, matchMode: FilterMatchMode.IN},
      };
    },
    manageRowNumber(event) {
      this.pageStartRowNumber = event.first;
    },
    async openAddAgreementDocument() {
      await this.getAllPrograms();
      this.generatedSwitch = false;
      this.AgreementDocumentName = null;
      this.ProgramName = null;
      this.AgreementDocumentId = 0;
      this.Path = null;
      this.displayAddAgreementDocument = true;
    },
    async openUpdateAgreementDocument(item) {
      let fN = 'openUpdateAgreementDocument: ';
      await this.getAllPrograms();
      this.HTECHLogger(this.sCFN + fN + 'item = ' + JSON.stringify(item))
      this.AgreementDocumentId = item.Id;
      this.AgreementDocumentName = item.Name;
      this.Path = item.Path;
      this.generatedSwitch = false;
      if (null == item.Path || ('Janaan' == item.Path)) {
        this.generatedSwitch = true;
      }
      if (null != item.Code) {
        var obj = {};
        obj.Name = item.Code;
        this.ProgramName = obj;
      } else {
        this.ProgramName = null;
      }
      this.ProgramNameOriginal = this.ProgramName;
      this.displayUpdateAgreementDocument = true;
    },
    async saveAddAgreementDocument() {
      let fN = 'saveAddAgreementDocument: ';
      this.HTECHLogger(this.sCFN + fN)
      const formData = new FormData();
      formData.append("Code", this.ProgramName.Name);
      formData.append("Name", this.AgreementDocumentName);
      formData.append("Path", this.Path);
      return this.$API
        .post(this.$InsertAgreementDocument, formData, { withCredentials: true })
        .then(response => {
          if (response.status == 200) {
            console.log("Agreement Document Added");
            this.$toast.add({severity:'success', summary: 'Dokumen Perjanjian Telah Ditambah', detail:'', group: 'tr', life: 3000});
            this.getAllAgreementDocuments();
          } else console.log("Error Adding");
        })
        .catch(error => {
          console.log(error);
        });
      //this.displayAddAgreementDocument = false;
    },
    async saveUpdateAgreementDocument() {
      let fN = 'saveUpdateAgreementDocument: ';
      this.HTECHLogger(this.sCFN + fN + 'this.ProgramName = ' + JSON.stringify(this.ProgramName))
      this.HTECHLogger(this.sCFN + fN + 'this.AgreementDocumentId = ' + JSON.stringify(this.AgreementDocumentId))
      this.HTECHLogger(this.sCFN + fN + 'this.ProgramName.Name = ' + JSON.stringify(this.ProgramName.Name))
      this.HTECHLogger(this.sCFN + fN + 'this.ProgramName = ' + JSON.stringify(this.AgreementDocumentName))
//return;
        const formData = new FormData();
        formData.append("Id", this.AgreementDocumentId);
        formData.append("Code", this.ProgramName.Name);
        formData.append("Name", this.AgreementDocumentName);
        formData.append("Path", this.Path);
        return this.$API
          .post(this.$UpdateAgreementDocument, formData, { withCredentials: true })
          .then(response => {
            if (response.status == 200) {
              console.log("Agreement Document Updated");
              this.$toast.add({severity:'success', summary: 'Dokumen Perjanjian Telah Dikemaskini', detail:'', group: 'tr', life: 3000});
              this.getAllAgreementDocuments();
            } else console.log("Error Updating");
          })
          .catch(error => {
            console.log(error);
          });
      //}
      this.displayUpdateAgreementDocument = false;
    },
    searchAgreementDocument(event) {
      setTimeout(() => {
        if (!event.query.trim().length) {
          this.filteredAgreementDocuments = [...this.AllAgreementDocuments];
        }
        else {
          this.filteredAgreementDocuments = this.AllAgreementDocuments.filter((item) => {
            return item.Name.toLowerCase().startsWith(event.query.toLowerCase());
          });
        }
      }, 250);
    },
    setToggleGenratedSwitch() {
      if (true == this.generatedSwitch) {
        this.Path = 'Janaan';
      }
    },
    async softDeleteAgreementDocument(item) {
      let fN = 'softDeleteAgreementDocument: ';
      this.HTECHLogger(this.sCFN + fN + 'item = ' + JSON.stringify(item))
      this.$confirm.require({
        message: 'Pastikan dokumen perjanjian yang hendak dihapuskan ini\ntelah dihapuskan dari dokumen perjanjian program.\n\nAnda pasti untuk meneruskan?',
        header: 'Hapus',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: 'Ya',
        rejectLabel: 'Tidak',
        defaultFocus: 'reject',
        acceptClass: 'p-button-danger',
        rejectClass: 'p-button-primary',
        accept: () => {
          const formData = new FormData();
          formData.append("Id", item.Id);
          return this.$API
            .post(this.$DeleteAgreementDocument, formData, { withCredentials: true })
            .then(response => {
              if (response.status == 200) {
                console.log("Agreement Document Deleted");
                this.$toast.add({severity:'success', summary: 'Dokumen Perjanjian Telah Dihapus', detail:'', group: 'tr', life: 3000});
                this.getAllAgreementDocuments();
              } else console.log("Error Deleting");
            })
            .catch(error => {
              console.log(error);
            });
        },
        reject: () => {
          return;
        }
      });
    },
    async submitFileV4() {
      let fN = 'submitFileV4: ';
      let item = this.pdfToBeUploaded;
      if (null == item) {
        this.$dialog
            .alert("Pilih dokumen perjanjian untuk dimuat naik");
        this.HTECHLogger(this.sCFN + fN + 'item is null. Nothing to upload')
        return;
      }
      this.HTECHLogger(this.sCFN + fN + 'item = ' + JSON.stringify(item))
      if (null == this.ProgramName) {
        this.$dialog
            .alert("Pilih program");
        this.HTECHLogger(this.sCFN + fN + 'program is null. Nothing to upload')
        return;
      }
      if (typeof item.file.size === 'undefined') {
        this.$dialog.alert("Fail kosong");
      } else {
        var actualURL = 'Janaan';
        if (false == this.generatedSwitch) {
          actualURL = this.$offerDocumentURL + 'DokumenTawaran/' + this.ProgramName.Name + '/' + item.name;
          this.Path = actualURL;
        }
        this.HTECHLogger(this.sCFN + fN + 'programCode = ' + JSON.stringify(this.ProgramName))
        this.HTECHLogger(this.sCFN + fN + 'docName = ' + this.AgreementDocumentName)
        this.HTECHLogger(this.sCFN + fN + 'actualFileName = ' + item.name)
        this.HTECHLogger(this.sCFN + fN + 'actualURL = ' + actualURL)
//return;
        const formData = new FormData();
        formData.append("file", item.file);
        formData.append("programCode", this.ProgramName.Name);
        formData.append("docName", this.AgreementDocumentName);
        formData.append("actualURL", actualURL);
        formData.append("save", 1);
        formData.append("id", this.AgreementDocumentId);
        return this.$API
          .post(this.$UploadAgreementDocument, formData, { withCredentials: true, })
          .then((response) => {
            if (response.status == 200) {
              this.$dialog.alert("Muat Naik PDF Berjaya");
              console.log("Upload PDF Success");
              if (0 < this.AgreementDocumentId) {
                this.$toast.add({severity:'success', summary: 'Dokumen Perjanjian Telah Dikemaskini', detail:'', group: 'tr', life: 3000});
              } else {
                this.$toast.add({severity:'success', summary: 'Dokumen Perjanjian Telah Ditambah', detail:'', group: 'tr', life: 3000});
              }
              this.getAllAgreementDocuments();
            } else {
              console.log("Error Saving");
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
  }
};
</script>
<style>
.p-confirm-dialog-message {
  white-space: pre-line;
}
</style>
